import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// allowedRoles: Bu rotaya erişebilecek rollerin bir dizisi (örn: ['translator', 'admin'])
const ProtectedRoute = ({ children, allowedRoles }) => {
  const { user, token } = useAuth();
  const location = useLocation();

  if (token && !user) {
    return <div className="loading-screen">Authenticating...</div>;
  }

  if (!token || !user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Eğer bu rota için belirli roller gerekiyorsa VE kullanıcının rolü bu rollerden biri DEĞİLSE,
  // o zaman anasayfaya yönlendir.
  if (allowedRoles && !allowedRoles.includes(user.role)) {
      console.warn(`Unauthorized access attempt to a route requiring roles [${allowedRoles.join(', ')}] by user:`, user.email);
      return <Navigate to="/" replace />;
  }

  // Her şey yolundaysa, istenen sayfayı göster.
  return children;
};

export default ProtectedRoute;